// extracted by mini-css-extract-plugin
export default {"wrapper":"component_wrapper__bEPYV","container":"component_container__n-tHt","form":"component_form__2QSji","submitButton":"component_submitButton__4cgGD"};